import { Outlet } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { DashboardHeader } from "./DashboardHeader";
import { DashboardSidebar } from "./DashboardSidebar";
import { Input } from "../ui/input";
import { DashboardFooter } from "./DashboardFooter";
import { useAuth } from "@/context/AuthContext";
import SubscriptionAlert from "../shared/SubscriptionAlert";

export const DashboardLayout = () => {
  return (
    // <SidebarProvider>
    <div className="layout-light side-menu overlayScroll">
      <div className="mobile-search">
        <form className="search-form">
          <span data-feather="search"></span>
          <Input
            className="form-control mr-sm-2 box-shadow-none"
            type="text"
            placeholder="Search..."
          />
        </form>
      </div>
      <div className="mobile-author-actions"></div>
      <DashboardHeader />
      <main className="main-content">
        <DashboardSidebar />
        {/* <SubscriptionAlert /> */}
        {/* <div className="contents" style={{background:"white"}}> */}
        <div className="contents">
          <SubscriptionAlert />
          <Outlet />
        </div>

        {/* <DashboardFooter /> */}
      </main>
      <div id="overlayer">
        <span className="loader-overlay">
          <div className="atbd-spin-dots spin-lg">
            <span className="spin-dot badge-dot dot-primary"></span>
            <span className="spin-dot badge-dot dot-primary"></span>
            <span className="spin-dot badge-dot dot-primary"></span>
            <span className="spin-dot badge-dot dot-primary"></span>
          </div>
        </span>
      </div>
    </div>
  );
};
